export const getLocation = state => state.router.location;

export const getSearch = state => state.router.location.search;
